// extracted by mini-css-extract-plugin
export var item = "private-label-intro-module--item--szygh";
export var privateLabel = "private-label-intro-module--privateLabel--9bYvp";